<p-table
  [value]="paginationResult.entities"
  id="table"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [rows]="10"
  [rowsPerPageOptions]="[10,20,30,40,50]"
  [paginator]="true"
  [loading]="loading"
  [rowHover]="true"
  [showCurrentPageReport]="true"
	currentPageReportTemplate="
      {{ 'table.showing' | translate }} {first}
      {{ 'table.to' | translate }} {last}
      {{ 'table.of' | translate }} {totalRecords}
      {{ 'table.entries' | translate}}"
  class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    @if (showTitle) {
      <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
        {{ 'tableManagement.accessories.accessoriesManagement' | translate }}
      </div>
    }
  </ng-template>
  <!-- #endregion -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- EXTRA TYPE -->
      <!-- <th pSortableColumn="extrasType">
      <div class='d-flex align-items-center h-100'>
        !-- COLUMN TITLE --
        <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
          {{ 'general.type' | translate }}
        </div>

        !-- COLUMN SORT && FILTER ICONS --
        <div class="d-flex align-items-center h-100">
          !-- COLUMN SORT && FILTER ICONS --
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="extrasType"></p-sortIcon>
            <p-columnFilter field="extrasType" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-multiSelect [ngModel]="value" [options]="vehicleTypeList" i18n-placeholder placeholder="{{'general.filters.any' | translate}}" (onChange)="filter($event.value)" optionLabel="name" optionValue="id">
                  <ng-template let-option pTemplate="item">
                    <div class="p-multiselect-type-option">
                      <span class="ml-1">{{option.name}} ({{option.code}})</span>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </div>
        </div>
      </div>
    </th> -->

    <!-- DESCRIPTION -->
    <th pSortableColumn="description">
      <div class="d-flex align-items-center h-100">
        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'general.description' | translate }}
        </div>

        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="description"></p-sortIcon>
            <p-columnFilter field="description" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false">
            </p-columnFilter>
          </div>
        </div>

      </div>
    </th>

    <!-- SERIAL NUMBER -->
    <th pSortableColumn="serialNumber">
      <div class="d-flex align-items-center h-100">
        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'tableManagement.accessories.serialNumber' | translate }}
        </div>

        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="serialNumber"></p-sortIcon>
            <p-columnFilter field="serialNumber" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}"
              display="menu"
              [showMatchModes]="false"
              [showOperator]="false"
              [showAddButton]="false">
            </p-columnFilter>
          </div>
        </div>

      </div>
    </th>

    <!-- INSTALLATION DATE -->
    <th pSortableColumn="installationDate">
      <div class="d-flex align-items-center h-100">
        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'tableManagement.accessories.installationDate' | translate }}
        </div>

        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="installationDate"></p-sortIcon>
          </div>
        </div>

      </div>
    </th>

    <!-- DESINSTALLATION DATE -->
    <th pSortableColumn="desinstallationDate">
      <div class="d-flex align-items-center h-100">
        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'tableManagement.accessories.desinstallationDate' | translate }}
        </div>

        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="desinstallationDate"></p-sortIcon>
          </div>
        </div>

      </div>
    </th>

    <!-- ACTIVE -->
    <th pSortableColumn="enabled">
      <div class="d-flex align-items-center h-100">

        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'general.active' | translate }}
        </div>

        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <p-sortIcon field="!enabled"></p-sortIcon>
          <p-columnFilter field="!enabled" type="boolean" display="menu" [showApplyButton]="false"></p-columnFilter>
        </div>

      </div>
    </th>
    <!-- DELETE -->
    <th class="button-column"></th>
  </tr>


</ng-template>
<!-- #endregion  -->

<!-- #region TABLE BODY DEFINITION -->
<ng-template pTemplate="body" let-accessory>
  <tr class='p-selectable-row custom-rows' [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)='editVehicleAccessory(accessory)'>
    <td>{{accessory.description}}</td>
    <td>{{accessory.serialNumber}}</td>
    <td>{{accessory.installationDate | date: 'dd/MM/yyyy'}}</td>
    <td>{{accessory.desinstallationDate | date: 'dd/MM/yyyy'}}</td>
    <td>
      <div class="d-flex justify-content-center align-items-center">
        <i class="pi" [ngClass]="{'true-icon pi-check-circle': !accessory.disabled, 'false-icon pi-times-circle': accessory.disabled}"></i>
      </div>
    </td>
    <!-- DELETE -->
    <td>
      @if (isDisabledGranted) {
        <div>
          <button  type="button" class="btn custom-table-remove-button" (click)="onDeleteAccessories(accessory)">
            <svg-icon
              src="assets/icons/trash.svg"
              class="d-flex flex-wrap custom-table-remove-button-icon"
              [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
            ></svg-icon>
          </button>
        </div>
      }

    </td>
  </tr>
</ng-template>
<!-- #endregion -->

<!------ TABLE EMPTY MESSAGE ---------------------------------------------------------------->
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="6" class="p-0">
      <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
    </td>
  </tr>
</ng-template>

<!------ FOOTER ----------------------------------------------------------------------------->
<ng-template pTemplate="footer">
  <tr>
    <td colspan="6" class="p-0">
      <div class="d-flex flex-row align-items-center p-3 gap-3">
        <!-- ADD RACING EVENT BUTTON -->
        @if (isCreateGranted) {
          <app-table-add-button [text]=" 'tableManagement.accessories.accessory' | translate "
            (btnClick)="createVehicleAccessory()"
          ></app-table-add-button>
        }

        <!-- EXCEL BUTTON -->
        <app-table-excel-button class="buttonTableExcel"  (btnClick)="exportExcel()"></app-table-excel-button>
      </div>
    </td>
  </tr>
</ng-template>

</p-table>

<app-inventory-vehicle-accessory-form [vehicle]="vehicle">
</app-inventory-vehicle-accessory-form>
<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.message' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="inventory-vehicle-accessory-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>